import { SEARCHCUSTOMER_FAIL, SEARCHCUSTOMER_SUCCESS } from '../actionTypes';

const initialState = {
	user: []
};

const searchCustomerReducer = (state = initialState, action) => {
	switch (action.type) {
		case SEARCHCUSTOMER_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case SEARCHCUSTOMER_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default searchCustomerReducer;
